import { FunctionComponent, useMemo } from 'react'

import usePageMetadata from '@hooks/usePageMetadata'
import { createVideoSchema } from '@components/Schema/utils'
import SchemaHTMLElement from '@components/SchemaHTMLElement'

const VideoSchema: FunctionComponent = () => {
  const pageMetadata = usePageMetadata()
  const { video, videos } = pageMetadata.schema || {}

  const preparedVideo = useMemo(
    () =>
      (videos?.length ? videos : video ? [video] : [])
        .filter((videoItem) => !!videoItem?.videoId)
        .map((videoItem) => createVideoSchema({ ...videoItem, pageMetadata })),
    [pageMetadata, videos, video],
  )

  if (!preparedVideo.length) {
    return null
  }

  return (
    <>
      {preparedVideo.map((schemaObject) => (
        <SchemaHTMLElement
          key={schemaObject['@id']}
          scriptKey={schemaObject['@id']}
          schemaObject={schemaObject}
        />
      ))}
    </>
  )
}

export default VideoSchema
